export { default } from './VerticalChartFilter.component';
export type { VerticalChartFilterProps } from './VerticalChartFilter.component';
